import ProposalClientTeamView from "work/proposals/_views/_shared/proposal-client-team-view";
import { useProposalClientTeamRoster } from "work/proposals/_views/_shared/use-proposal-client-team-roster";
import ProposalBuilder from "work/proposals/__builder/proposal-builder";
import Proposal from "work/proposals/proposal";
import { type TeamLeaderRoleAction } from "work/proposals/leader-handover/_views/team-leader-role-cell";

export default function DraftProposalClientTeamTab({
  proposal,
  proposalBuilder,
  negotiationId,
  canEdit,
  isDrawerOpen,
  leaderActions,
  onProposalBuilderUpdated,
}: {
  proposal?: Proposal;
  proposalBuilder: ProposalBuilder;
  negotiationId?: string;
  canEdit?: boolean;
  isDrawerOpen?: boolean;
  /** Actions in the leader row's Role cell, such as handing the draft over to the leader (#6579). */
  leaderActions?: readonly TeamLeaderRoleAction[];
  onProposalBuilderUpdated: (proposalBuilder: ProposalBuilder) => void;
}) {
  const isUnsavedProposal = !proposal?.id;
  // A created draft stages its roster on the negotiation, so the page's Save writes it. An
  // uncreated one has no negotiation to stage against and keeps putting its members straight into
  // the builder — which the page's Save has always been what persists. Either way the roster waits
  // for an explicit press (#5116).
  const roster = useProposalClientTeamRoster(isUnsavedProposal ? undefined : negotiationId);

  return (
    <ProposalClientTeamView
      proposal={proposal}
      clientTeam={proposalBuilder.currentSpec.workAgreement.clientTeam ?? null}
      negotiationId={negotiationId}
      canEdit={canEdit}
      showTemplates
      isDrawerOpen={isDrawerOpen}
      leaderActions={leaderActions}
      // A saved draft keeps a removed member drawn, with an Undo, until the save (#6995).
      undoStagedRemovals={!isUnsavedProposal}
      members={roster?.members}
      hasUnsavedChanges={roster?.hasUnsavedChanges}
      changedElsewhereWhileEditing={roster?.changedElsewhereWhileEditing}
      onMembersChanged={
        isUnsavedProposal
          ? (members) => onProposalBuilderUpdated(proposalBuilder.setClientTeamMembers(members))
          : roster?.stageMembers
      }
    />
  );
}
